<template>
  <v-modal name="deploy" @modalShow="generateConfiguration">
    <v-panel class="rounded deploy">
      <template #header>
        <h3>
          <v-icon name="eye" />
          {{ $t('Preview Configuration') }}
        </h3>
      </template>
      <template #default>
        <v-deploy :disabled="!app.connectionParameters.canScan" :show-restart="true" />
        <pre class="code">{{ configuration }}</pre>
      </template>
    </v-panel>
  </v-modal>
</template>
<script lang="ts" setup>
import { useStore } from '/@/shared/composables/store'
import { useFlits } from '@vectioneer/ui'
import { $t } from '/@/i18n'
import { ref } from 'vue'

const { app, ethercat } = useStore()
const flits = useFlits()

const configuration = ref('')

const generateConfiguration = async () => {
  try {
    configuration.value = await ethercat.generateConfiguration()
  } catch (error) {
    flits.error(error)
  }
}
</script>
<style src="./style.css"></style>
